import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { APSMaster, WebSwoDeliveryRequest, WebCompany, WebCustomer, ContactWeb } from "src/app/models";
import { ApsService, UtilityService, CompanyService, CustomerService, ContactService } from "src/app/services";
import { ConfirmDialogService, ConfirmDialogOptions } from "src/app/shared";
import { EditCardDialogService } from "src/app/pages/aps/edit-card-dialog/edit-card-dialog.service"
import { AlertDialogComponent } from "src/app/components/alert-dialog/alert-dialog.component";
import { ErrorDialogComponent } from "src/app/components/error-dialog/error-dialog.component";
import { filter } from "rxjs/operators";


@Component({
  selector: "app-card-item",
  templateUrl: "./card-item.component.html",
  styleUrls: ["./card-item.component.scss"],
})
export class CardItemComponent implements OnInit, OnDestroy
{
  @Input() card: APSMaster;
  dialogRef: any;
  private availableCardsSubscription: Subscription;
  public availableCards: APSMaster[];
  private availableBanksSubscription: Subscription;
  public availableBanks: APSMaster[];
  companySubscription: Subscription;
  company: WebCompany;

  customerSubscription: Subscription;
  customer: WebCustomer;

  contactList: ContactWeb[];
  contactSubscription: Subscription;
  defaultEmail: string = ""
  requestData: WebSwoDeliveryRequest = {};

  constructor(
    private apsService: ApsService,
    public dialog: MatDialog,
    private confirmDialogService: ConfirmDialogService,
    private editCardDialogService: EditCardDialogService,
    private utilityService: UtilityService,
    private customerService: CustomerService,
    private companyService: CompanyService,
    private contactService: ContactService,
  ) { }
  ngOnInit(): void
  {
    this.availableBanksSubscription = this.apsService.availableBanks.subscribe(
      (banks) =>
      {
        this.availableBanks = banks;
      }
    );

    this.availableCardsSubscription = this.apsService.availableCards.subscribe(
      (cards) =>
      {
        this.availableCards = cards;
      }
    );

    this.customerSubscription = this.customerService.customer
      .pipe(filter(customer => !!customer))
      .subscribe(customer =>
      {
        this.customer = customer;
      });

    this.companySubscription = this.companyService.company.subscribe((e) =>
    {
      this.company = e;
    });

    this.contactSubscription = this.contactService.contacts.subscribe((c) =>
    {
      this.contactList = c;
      this.defaultEmail = this.setDefaultEmail();
    });
  }

  public handleEditClick(): void
  {
    this.editCardDialogService.openDialog(this.card)

  }

  public handleDeleteClick(): void
  {
    this.requestData.ContactEmail = this.defaultEmail;
    this.requestData.CustId = this.customer.CustId;
    this.requestData.Contact = this.customer.Name;
    this.requestData.Company = this.company;
    this.requestData.Customer = this.customer;

    if (
      this.apsService.isAutoPayOn &&
      (this.availableBanks.length === 0 && this.availableCards.length === 1)
    )
    {
      const dialogData = new ConfirmDialogOptions(
        "Delete Credit Card?",
        "To remain enrolled in Autopay, you must have a payment account on file. If you wish to remain on Autopay, select No, add a new form of payment and delete this card. Deleting this card will terminate your enrollment in Autopay. Continue?"
      );

      this.confirmDialogService
        .openDialog(dialogData)
        .afterClosed()
        .subscribe((result) =>
        {
          if (result)
          {
            this.apsService.deletePaymentMethod(this.card).subscribe({
              next: () =>
              {
                this.utilityService.sendAutopayCancellationEmails(this.requestData).subscribe({
                  next: (r) =>
                  {
                    if (r)
                    {
                      this.dialogRef = this.dialog.open(AlertDialogComponent, {
                        id: "register-alert",
                        panelClass: "form-field-less-than-180",
                        width: "500px",
                        height: "200px",
                        data: {
                          title: "Autopay Cancellation",
                          message: "Your account will be removed from Autopay.",
                          buttonText: "Close"
                        }
                      });
                    }
                    else
                    {
                      this.errorDialog("The card was deleted, but autopay cancellation email failed.");
                    }
                  },
                  error: (error) =>
                  {
                    this.errorDialog("The card was deleted, but there was a problem sending the autopay cancellation email. " + error);
                  }
                });
              },
              error: (error) =>
              {
                this.errorDialog("There was a problem deleting your card. " + error);
              }
            });
          }
        });
    }
    else
    {
      const dialogData = new ConfirmDialogOptions(
        "Delete Credit Card",
        `Delete card ending in ${ this.card.MaskedCardNo }?`
      );

      this.dialogRef = this.confirmDialogService
        .openDialog(dialogData)
        .afterClosed()
        .subscribe((result) =>
        {
          if (result)
          {
            this.apsService.deletePaymentMethod(this.card).subscribe({
              next: () =>
              {
              },
              error: (error) =>
              {
                this.errorDialog("There was a problem deleting your card. " + error);
              }
            });
          }
        });
    }
  }

  errorDialog(error): void
  {
    this.dialog.open(ErrorDialogComponent, {
      minWidth: "360px",
      data: error,
    });
  }

  public setDefaultEmail(): string
  {
    if (this.contactList.length > 0)
    {
      if (this.contactList[0] !== null || this.contactList[0].Email !== "")
      {
        this.defaultEmail = this.contactList[0].Email;
      }
    }
    return this.defaultEmail;
  }

  ngOnDestroy(): void
  {
    this.availableBanksSubscription.unsubscribe();
    this.availableCardsSubscription.unsubscribe();
    this.customerSubscription.unsubscribe();
    this.companySubscription.unsubscribe();
    this.contactSubscription.unsubscribe();
  }
}
